import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Community from "./pages/Community";
import Claim from "./pages/Claim";
import Mint from "./pages/Mint";
import PonksList from "./pages/PonksList";
import UserDashboard from "./pages/UserDashboard";
import BasedHome from "./pages/BasedHome";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Landing page */}
        <Route path="/" element={<BasedHome/>} />
        
        {/* Based Ponks pages */}
        <Route path="/community" element={<Community />} />
        <Route path="/claim" element={<Claim />} />
        <Route path="/mint" element={<Mint />} />
        <Route path="/ponks" element={<PonksList />} />
        <Route path="/dashboard" element={<UserDashboard />} />
      </Routes>
    </Router>
  );
}
